import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetirementinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.1,
			d: "M3.333 17.5h13.334"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.1,
			d: "M7.58 3.055a6.966 6.966 0 0 0-3.98 8.318l.063.221a1.662 1.662 0 0 0 2.25 1.076l9.74-4.135c.92-.39 1.29-1.5.788-2.366l-.115-.199a6.966 6.966 0 0 0-8.747-2.915",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.1,
			d: "m7.58 3.055-.216.872a8.88 8.88 0 0 0 1.532 7.476v0M7.58 3.055l.777.45a8.88 8.88 0 0 1 4.313 6.297v0M10.784 10.6l2.925 6.9"
		})
	]
});
export default SvgRetirementinline;
